<template>
    <div>
        <b-modal
            v-model="modalShow"
            class="ext-modal ext-modal--xl p-reservation"
            :title="title"
            @hidden="close">
            <div class="modal-body">
                {{ bodyText }}
            </div>

            <div slot="modal-footer" class="w-100">
                <b-button v-if="!okHidden" variant="yokumiru-orange" class="float-right" :href="link">{{ okText }}</b-button>
                <b-button variant="yokumiru-gray" class="float-right mr-2" @click="close">{{ cancelText }}</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'PageTransitionModal',

        props: {
            okText: {
                type: String,
                default: 'ok',
            },
            okHidden: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'cancel',
            },
            link: {
                type: String,
                default: '/',
            },
        },

        data: function () {
            return {
                modalShow: false,
                title: '',
                bodyText: '',
            }
        },

        created: function () {
            bus.$on('open-modal-page-transition', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-page-transition')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {string} title
             * @param {string} bodyText
             */
            open: function (title, bodyText) {
                this.modalShow = true
                this.title = title
                this.bodyText = bodyText
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * 閉じるボタン押下時
             */
            handleOk: function (e) {
                e.preventDefault()
                this.close()
            },
        },
    }
</script>
